export const BASE_URL = "https://myedudiary.com/sms";
export const ACCOUNTS_URL = "https://myedudiary.com/school_accounts";
// export const IMG_URL = "https://myedudiary.com/sms/uploads/";
